import { MimeTypes } from "../types";
import { encode } from "./dataEncoder";

export const base64ToUint8Array = (base64: string) => {
  const binaryString = window.atob(base64);
  const binaryLen = binaryString.length;
  const bytes = new Uint8Array(binaryLen);
  for (let i = 0; i < binaryLen; i++) {
    const ascii = binaryString.charCodeAt(i);
    bytes[i] = ascii;
  }
  return bytes;
};

export const arrayBufferToBase64 = (buffer: ArrayBuffer | null) => {
  if (!buffer) return;
  let binary = "";
  const bytes = new Uint8Array(buffer);
  const len = bytes.byteLength;
  for (let i = 0; i < len; i++) {
    binary += String.fromCharCode(bytes[i]);
  }
  return window.btoa(binary);
};

export const getPhotoUrls = (imgUrls: any[]) => {
  try {
    const urls = imgUrls.map((data) => {
      const bytes = base64ToUint8Array(data);
      return `data:application/octet-stream;base64,${encode(bytes as any)}`;
    });
    return Promise.resolve(urls);
  } catch (e) {
    return Promise.reject(e);
  }
};

export const prepareForUplaod = (myFile: Blob) => {
  const reader = new FileReader();
  const fileByteArray: any = [];
  reader.readAsArrayBuffer(myFile);
  reader.onloadend = (evt) => {
    if (!evt.target?.result || !(evt.target.readyState === FileReader.DONE))
      return;
    const arrayBuffer = evt.target.result;
    const array = new Uint8Array(arrayBuffer as ArrayBufferLike);
    for (let i = 0; i < array.length; i++) {
      fileByteArray.push(array[i]);
    }
  };
  return fileByteArray;
};

export const handleLinkDownload = (blob: Blob, fileName: string) => {
  const link = document.createElement("a");
  document.body.appendChild(link);
  const url = window.URL.createObjectURL(blob);
  link.href = url;
  link.download = fileName;
  link.click();
  window.URL.revokeObjectURL(url);
  document.body.removeChild(link);
};

export const downloadFile = (
  data: string,
  saveName: string,
  type: keyof typeof MimeTypes
) => {
  if (!data) return;
  const bytes = base64ToUint8Array(data);
  const blob: Blob = new Blob([bytes], { type: MimeTypes[type] });

  // some version can work with msSaveBlob,
  // even though ts interface doesn't include it
  // we have to alter global interface
  if (navigator.msSaveBlob) {
    navigator.msSaveBlob(blob, saveName);
  } else {
    handleLinkDownload(blob, saveName);
  }
};

const reverseString = (str: string): string => {
  if (str === "") return "";
  return reverseString(str.slice(1)) + str.charAt(0);
};

export const getFileType = (fileName: string) => {
  const reversedName = reverseString(fileName);
  const dotIndex = reversedName.indexOf(".");
  if (!dotIndex) return "";
  return reverseString(reversedName.slice(0, dotIndex));
};
